import request from '@/utils/request';
const basePath = '/open/quotationDouBao';

/**
 * 验证校验码是否可以询价（抖包询价）
 */
export function verifyCode(code) {
    return request.Boss.noTip.post(basePath + '/verifyCode', {}, { code })
}

/**
 * 获取抖包询价配置信息
 */
export function getConfigInfo(code) {
    return request.Boss.noTip.post(basePath + '/config', {}, { code })
}

/**
 * 获取城市列表（抖包询价）
 */
export function getCityList(code, province) {
    return request.Boss.noTip.post(basePath + '/city/list', {}, { code, province })
}

/**
 * 获取行业二级分类列表（抖包询价）
 */
export function getSubCategoryList(code, category) {
    return request.Boss.noTip.post(basePath + '/subCategory/list', {}, { code, category })
}

/**
 * 获取行业三级分类列表（抖包询价）
 */
export function getSubSubCategoryList(code, category, subCategory) {
    return request.Boss.noTip.post(basePath + '/subSubCategory/list', {}, { code, category, subCategory })
}

/**
 * 计算价格（抖包询价）
 */
export function mathPriceInfo(postData) {
    return request.Boss.noTip.post(basePath + '/math', postData)
}

/**
 * 城市模糊搜索（抖包询价）
 */
export function searchCity(code, keyword) {
    return request.Boss.noTip.post(basePath + '/city/search', {}, { code, keyword })
}

/**
 * 包含城市的省份模糊搜索（抖包询价）
 */
export function searchProvinceIncludeCity(code, keyword) {
    return request.Boss.noTip.post(basePath + '/province/includeCity/search', {}, { code, keyword })
}

/**
 * 行业分类及子类模糊搜索（抖包询价）
 */
export function searchIndustry(code, keyword) {
    return request.Boss.noTip.post(basePath + '/industry/search', {}, { code, keyword })
}

/**
 * 包含行业子类的行业分类模糊搜索（抖包询价）
 */
export function searchCategoryIncludeSubCategory(code, keyword) {
    return request.Boss.noTip.post(basePath + '/category/includeSubCategory/search', {}, { code, keyword })
}
